<div class="card card-nav-tabs mt-0 rounded-lg border-0 container p-4 shadow">

    <div class="mb-4 d-none">
        <label for="trust_type" class="form-label text-xxs">Select Trust Type</label>
        <select id="trust_type" class="form-select text-xxs rounded-3 shadow-sm" v-model="selected_trust_type">
          <option disabled hidden=""></option>
          <option value="family">Family Trust</option>
          <option value="unit">Unit Trust</option>
          <option value="discretionary">Discretionary Trust</option>
        </select>
    </div>

    <p class="text-xxs mb-2 mt-3 fw-bold">Send Forms to Client</p>
    <div class="table-responsive mt-3">
      <table class="table table-hover">
        <thead class="custom-header">
          <tr>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Select</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Form Name</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Form Description</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="form in forms" :key="form.id">
            <td class="text-xxs text-start">
              <div class="form-check d-flex justify-content-center">
                <input class="form-check-input" type="checkbox" v-model="form.selected">
              </div>
            </td>
            <td class="text-xxs text-start">{{ form.name }}</td>
            <td class="text-xxs text-start">{{ form.form_description || '—' }}</td>
            <td class="text-xxs text-start">
              <button
                class="btn btn-primary-dark btn-sm text-xxs"
                @click="view_form(form)"
                data-bs-toggle="modal" data-bs-target="#view_form"
              >
                View
              </button>
            </td>

          </tr>
        </tbody>
      </table>
    </div>

    <div class="d-flex align-items-center gap-3 mt-3">
      <button class="btn btn-primary-dark btn-sm text-xxs" @click="send_selected">
        Send Selected Forms
      </button>
    </div>

<teleport to="body">
    <div class="modal fade" id="view_form" tabindex="-1" aria-labelledby="view_form_label" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <h5 class="modal-title text-white text-xxs" id="view_form_label">
              Preview: {{ preview_form.form_name }}
            </h5>
            <button
              type="button"
              class="btn-close modal-btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          <div class="modal-body contract-scrollable">
            <div
              v-for="(preview_section, si) in preview_form.sections" :key="preview_section.id" class="mb-4">
              <div class="bg-green-dark p-2 mb-2 mt-2 text-center rounded-pill py-1 px-2">
                <span>{{ preview_section.name }}</span>
              </div>

              <div class="card border table-border-color rounded-lg">
                <div class="card-body">
                  <div
                    v-for="(question, qi) in preview_section.questions"
                    :key="question.id"
                    class="mb-4"
                  >
                    <div class="row mb-2">
                      <div class="col">
                        <label class="form-label text-xs fw-bold">
                          Question {{ qi + 1 }}: {{ question.question_text }}
                        </label>
                      </div>
                    </div>

                    <!-- Input Field -->
                    <div class="row mb-2">
                      <div class="col-md-8">
                        <!-- Text/Number -->
                        <input
                          v-if="['short_text', 'long_text', 'number'].includes(question.question_type.question_type)"
                          type="text"
                          class="form-control text-xxs rounded-small shadow-sm"
                          :placeholder="'Enter ' + question.question_text"
                        />

                        <!-- Date -->
                        <input
                          v-else-if="question.question_type.question_type === 'date'"
                          type="date"
                          class="form-control text-xxs rounded-small shadow-sm"
                        />

                        <!-- Single Select -->
                        <select
                          v-else-if="question.question_type.question_type === 'single_select'"
                          class="form-select text-xxs rounded-small shadow-sm"
                        >
                          <option
                            v-for="opt in (question.multi_select_choices || question.options || [])"
                            :key="opt.id || opt"
                          >
                            {{ typeof opt === 'object' ? opt.choice : opt }}
                          </option>
                        </select>

                        <!-- Multi Select -->
                        <select
                          v-else-if="question.question_type.question_type === 'multi_select'"
                          multiple
                          class="form-select text-xxs rounded-small shadow-sm"
                        >
                          <option
                            v-for="opt in (question.multi_select_choices || question.options || [])"
                            :key="opt.id || opt"
                          >
                            {{ typeof opt === 'object' ? opt.choice : opt }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- Read-only Metadata -->
                    <div class="row">
                      <div class="col-md-6">
                        <label class="form-label text-xs"><small>Data Point</small></label>
                        <input
                          :value="question.key_data_points?.[0]?.data_point_name || 'Not assigned'"
                          type="text"
                          class="form-control text-xxs rounded-small shadow-sm"
                          readonly
                        />
                      </div>
                      <div class="col-md-6">
                        <label class="form-label text-xs"><small>Tag</small></label>
                        <input
                          :value="question.tag?.tag_name || 'Not assigned'"
                          type="text"
                          class="form-control text-xxs rounded-small shadow-sm"
                          readonly
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </teleport>

</div>
